import React, { useState } from "react";
import "../styles/ReturnOrderPage.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";
import Footer from "../../../../components/Footer/Footer";
import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import ReturnOrderForm from "../components/return/ReturnOrderForm";
import ReturnOrderItems from "../components/return/ReturnOrderItems";
import RetuenConfirmModal from "../components/return/ReturnConfirmModal";
import { useReturnOrder } from "../hooks/useReturnOrder";

const ReturnOrderPage = () => {
  const navigate = useNavigate();
  const { orderNo } = useParams();
  const { state } = useLocation();
  const items = state?.items || [];
  const [showModal, setShowModal] = useState(false);
  const returnData = useReturnOrder(orderNo, items, navigate);
  const breadcrumbPaths = [
    { label: "Orders", to: "/accounts/orders" },
    { label: "Cancel Order" },
  ];

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        transition={Slide}
      />
      <Breadcrumbs paths={breadcrumbPaths} />
      <div className="cancel-order-container">
        <ReturnOrderForm
          reason={returnData.reason}
          setReason={returnData.setReason}
          reasonList={returnData.reasonList}
          comments={returnData.comments}
          setComments={returnData.setComments}
          loading={returnData.loading}
          openModal={() => setShowModal(true)}
        />
        <ReturnOrderItems items={items} />
      </div>
      <RetuenConfirmModal
        show={showModal}
        close={() => setShowModal(false)}
        confirm={returnData.submitCancel}
        loading={returnData.loading}
      />
      <Footer />
    </>
  );
};

export default ReturnOrderPage;